import { useBrand } from '~/composables/useBrand';
import useSelectedPlan from '~/modules/worry-no-more/composables/useSelectedPlan';
import { useWnmSlideout } from '~/modules/worry-no-more/composables/useWnmSlideout';
import { useWnm } from '~/modules/worry-no-more/composables/useWnm';
import useExperiments from '~/stores/useExperimentsStore';
import { useStickyAtbSlideoutContextEnabled } from '~/modules/sticky-product-traits/composables/context-providers/useStickyAtbSlideoutContextEnabled';

export function useWnmAtbGate() {
  const { isMcom } = useBrand();
  const { experimentFlags } = useExperiments();
  const { isWnmVisible, isWnmFlyoutEligible } = useWnm();
  const { isStickyAtbSlideoutContextEnabled } = useStickyAtbSlideoutContextEnabled();
  const { selectedPlanId } = useSelectedPlan();
  const { openWnmSlideout } = useWnmSlideout();

  function shouldPromptWnmBeforeAtb(): boolean {
    return (
      isMcom &&
      !isStickyAtbSlideoutContextEnabled &&
      !experimentFlags.isWnmFlyoutDisabled &&
      isWnmVisible.value &&
      isWnmFlyoutEligible.value &&
      selectedPlanId.value === null
    );
  }

  function promptWnmBeforeAtb(callback?: () => void): void {
    if (!shouldPromptWnmBeforeAtb()) {
      callback?.();
      return;
    }

    openWnmSlideout({
      onClose: callback,
      skipErrorSlideout: false,
    });
  }

  return {
    shouldPromptWnmBeforeAtb,
    promptWnmBeforeAtb,
  };
}

export default useWnmAtbGate;
